import React, { useEffect } from 'react'
import { Link as RouterLink, useHistory } from 'react-router-dom'
import { Button, ChevronRightIcon, PlusIcon } from '@diversioteam/diversio-ds'
import { Skeleton } from '@material-ui/lab'

import { useGetPulseSurveys } from 'hooks/pulseSurveys/useGetPulseSurveys'
import { generateCompanyURI } from 'sagas/helpers/generateCompanyURI'
import { useCreatePulseSurvey } from 'hooks/pulseSurveys/useCreatePulseSurvey'
import { AppRoute } from 'routing/AppRoute.enum'
import { useGetPulseSurveysTemplates } from 'hooks/pulseSurveys/useGetPulseSurveysTemplates'
import { usePulseSurveys } from 'hooks/usePulseSurveys'

import { SurveyListItem } from './SurveyListItem'
import { TemplateListItem } from './TemplateListItem'
import { ListItemSkeleton } from './ListItemSkeleton'
import * as S from './panel.styles'

export const Panel = () => {
    const history = useHistory()
    const { onChangeActivePulseSurvey, activePulseSurvey } = usePulseSurveys()
    const { data: pulseSurveysData, isLoading: pulseSurveysIsLoading } = useGetPulseSurveys()

    const { data: pulseSurveysTemplates, isLoading: pulseSurveysTemplatesIsLoading } = useGetPulseSurveysTemplates({
        page: 1,
        page_size: 2,
    })

    const isLoading = pulseSurveysIsLoading || pulseSurveysTemplatesIsLoading

    const { mutate, isLoading: mutationIsLoading } = useCreatePulseSurvey()

    const hasPastSurveys = pulseSurveysData && pulseSurveysData.length > 0

    const handleCreateSurvey = () => {
        mutate()
    }

    useEffect(() => {
        if (pulseSurveysData && pulseSurveysData.length === 0 && activePulseSurvey) {
            onChangeActivePulseSurvey(null)
            history.replace(generateCompanyURI(AppRoute.PulseSurvey))
        }
    }, [pulseSurveysData, hasPastSurveys, activePulseSurvey, onChangeActivePulseSurvey, history])

    return (
        <S.PanelWrapper>
            <S.Panel>
                <S.Group>
                    <Button
                        color="secondaryLight"
                        onClick={handleCreateSurvey}
                        rightIcon={<PlusIcon type="line" />}
                        loading={mutationIsLoading}
                        fullWidth
                    >
                        New Survey
                    </Button>
                </S.Group>

                {(hasPastSurveys || isLoading) && (
                    <>
                        <S.Group>
                            <S.Title>Recent Surveys</S.Title>

                            <S.List>
                                {pulseSurveysIsLoading
                                    ? new Array(4).fill('').map((_, index) => <ListItemSkeleton key={index} />)
                                    : pulseSurveysData?.map((pulseSurvey) => (
                                          <SurveyListItem key={pulseSurvey.uuid} {...pulseSurvey} />
                                      ))}
                            </S.List>
                        </S.Group>

                        <S.Group>
                            <S.Title>Use a Template</S.Title>

                            <S.List>
                                {}

                                {pulseSurveysTemplatesIsLoading
                                    ? new Array(2).fill('').map((_, index) => <ListItemSkeleton key={index} />)
                                    : pulseSurveysTemplates?.items.map((pulseSurveyTemplate) => (
                                          <TemplateListItem key={pulseSurveyTemplate.uuid} {...pulseSurveyTemplate} />
                                      ))}

                                <S.ListItemWrapper
                                    as={RouterLink}
                                    to={generateCompanyURI(AppRoute.PulseSurveyTemplates)}
                                >
                                    <S.ListItemLabel>
                                        All Templates (
                                        {pulseSurveysTemplatesIsLoading ? (
                                            <Skeleton width={12} />
                                        ) : (
                                            pulseSurveysTemplates?.total
                                        )}
                                        )
                                    </S.ListItemLabel>

                                    <Button color="transparent" iconOnly aria-hidden={true} aria-label="">
                                        <ChevronRightIcon type="line" />
                                    </Button>
                                </S.ListItemWrapper>
                            </S.List>
                        </S.Group>
                    </>
                )}
            </S.Panel>
        </S.PanelWrapper>
    )
}
